<template>
  <!-- 高薪申报 -->
  <div id="declaration">
    <herder-img :imgs="imgs"></herder-img>
    <!-- 领域 -->
    <div class="auditing-serve">
      <h1 class="serve-h1">高新技术企业认证的主要领域</h1>
      <div class="serve-content">
        <div class="content-item">
          <img src="./images/组 2900.png" alt />
          <span></span>
          <h4>电子信息技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2901.png" alt />
          <span></span>
          <h4>生物与新医药技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2902.png" alt />
          <span></span>
          <h4>航空航天技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2903.png" alt />
          <span></span>
          <h4>新材料技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2904.png" alt />
          <span></span>
          <h4>高技术服务业</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2905.png" alt />
          <span></span>
          <h4>新能源及节能技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2906.png" alt />
          <span></span>
          <h4>资源与环境技术</h4>
        </div>
        <div class="content-item">
          <img src="./images/组 2907.png" alt />
          <span></span>
          <h4>先进制造与自动化</h4>
        </div>
      </div>
    </div>
    <!-- 中税代办注册优势 -->
    <div class="advantage">
      <h1 class="advantage-h2">高薪技术企业优势</h1>
      <div class="advantage-items">
        <div class="item">
          <img src="./images/蒙版组 12.png" alt />
          <div class="item-text">
            <h3>提升企业品牌形象</h3>
            <p>证明企业科研创新能力，提升品牌知名度，有利于企业招投标</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 13.png" alt />
          <div class="item-text">
            <h3>享受税收减免优惠政策</h3>
            <p>享受15%企业所得税低税率，研发费扣除提高至175%</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 14.png" alt />
          <div class="item-text">
            <h3>促进企业科技转型</h3>
            <p>政府引导支持，激发企业自主创新的热情，提高科技创新能力</p>
          </div>
        </div>
        <div class="item">
          <img src="./images/蒙版组 15.png" alt />
          <div class="item-text">
            <h3>提高企业资本价值</h3>
            <p>地方政府对企业实施优惠政策和资金扶持，最高60万补贴</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 常见的项目申报 -->
    <div class="decl-options">
      <h1 class="options-h1">常见的项目申报</h1>
      <div class="options-items">
        <div class="item item1">
          <div class="item-text-h4">
            <h4 class="h4-blue">国家高新技术企业</h4>
          </div>
          <div class="item-content">
            <div class="content-text">
              <div class="text-h4">
                  <h4>申报好处</h4>
                </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-blue">1</p>
                </div>
                <div class="line-title">
                  <p class="h4-blue">财政奖励</p>
                </div>
                <div class="line-msg">
                  <p>2019年杭州市区两级财政奖励60万元</p>
                </div>
              </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-blue">2</p>
                </div>
                <div class="line-title">
                  <p class="h4-blue">税收减免</p>
                </div>
                <div class="line-msg">
                  <p>研发费用享175%税前扣除，企业所得税减免40%</p>
                </div>
              </div>
              <h4 class="apply">适用企业</h4>
              <p>1.注册成立一年以上</p>
              <p>2.企业拥有核心知识产权的所有权</p>
              <p>3.企业从事研发的科技人员占比不低于10%</p>
              <p>4.企业近三个会计年度研发费用占同期销售收入总额的比例，根据情况不同分别为5%、4%、3%</p>
              <p>5.近一年高新技术产品（服务）收入占企业同期总收入的比例不低于60%</p>
            </div>
          </div>
        </div>
        <div class="item item2">
          <div class="item-text-h4 item-text-h4-two">
            <h4 class="h4-green">杭州市高新技术企业</h4>
          </div>
          <div class="item-content">
            <div class="content-text">
              <div class="text-h4">
                  <h4>申报好处</h4>
                </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-green">1</p>
                </div>
                <div class="line-title">
                  <p class="h4-green">财政奖励</p>
                </div>
                <div class="line-msg">
                  <p>2019年杭州市给予20万元培育经费资助</p>
                </div>
              </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-green">2</p>
                </div>
                <div class="line-title">
                  <p class="h4-green">政策扶持</p>
                </div>
                <div class="line-msg">
                  <p>研发费用享175%税前扣除，贷款贴息补助</p>
                </div>
              </div>
              <h4 class="apply">适用企业</h4>
              <p>1.注册成立一年以上</p>
              <p>2.从事研发和创新活动的科技人员占比不低于10%</p>
              <p>3.企业近三个年度研发费用占同期销售收入总额的比例，根据情况不同分别为5%、4%、3%</p>
              <p>4.近一年高新技术产品（服务）收入占企业同期总收入的比例不低于50%</p>
            </div>
          </div>
        </div>
        <div class="item item3">
          <div class="item-text-h4 item-text-h4-three">
            <h4 class="h4-yellow">
              杭州市初创型科技企业
              <br />（雏鹰计划）
            </h4>
          </div>
          <div class="item-content">
            <div class="content-text">
              <div class="text-h4">
                  <h4>申报好处</h4>
                </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-yellow">1</p>
                </div>
                <div class="line-title">
                  <p class="h4-yellow">财政奖励</p>
                </div>
                <div class="line-msg">
                  <p>2019年杭州市给予20万元奖励</p>
                </div>
              </div>
              <div class="text-line">
                <div class="line-num">
                  <p class="h4-yellow">2</p>
                </div>
                <div class="line-title">
                  <p class="h4-yellow">政策扶持</p>
                </div>
                <div class="line-msg">
                  <p>研发费用享175%税前扣除，贷款贴息补助</p>
                </div>
              </div>
              <h4 class="apply">适用企业</h4>
              <p>1.注册成立一年以上</p>
              <p>2.注册资金不高于1000万元</p>
              <p>3.研发人员占15%以上，研发经费单独建账，研发投入占当年主营收入5%以上</p>
              <p>4.年销售额在3000万元以下</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HerderImg from "@/common/herder-img";
export default {
  name: "declaration",
  data() {
    return {
      imgs: require("./images/组 2899.png")
    };
  },
  components: {
    HerderImg
  }
};
</script>

<style lang="scss" scoped>
// 领域
.auditing-serve {
  width: 1040px;
  margin: 40px auto;
  // margin: 40px 0;
  // padding: 0 10%;
  .serve-h1 {
    margin-bottom: 30px;
    color: #000;
  }
  .serve-content {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    .content-item {
      width: 23.4%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-shadow: 0 0 5px #cccccc;
      margin-bottom: 15px;
      border-radius: 10px;
      img {
        width: 30%;
        padding: 15% 0;
      }
      span {
        width: 30%;
        border-top: 1px solid #ccc;
      }
      h4 {
        padding: 20% 0;
        font-size: 13px;
        color: #000;
      }
    }
  }
}
// 作用
.advantage {
  width: 100%;
  display: flex;
  flex-direction: column;
  // padding: 0 10%;
  box-sizing: border-box;
  align-items: center;
  padding-bottom: 50px;
  background-color: rgb(243, 243, 243);
  .advantage-h2 {
    padding: 30px 0;
    color: #000;
  }
  .advantage-items {
    width: 1040px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .item {
      width: 24%;
      box-sizing: border-box;
      background-color: #ffffff;
      padding: 10px;
      img {
        width: 100%;
      }
      .item-text {
        width: 100%;
        box-sizing: border-box;
        text-align: center;
        padding: 10px 0 0 0;
        h3 {
          line-height: 30px;
        }
        p {
          color: rgb(92, 92, 92);
          margin: 0 8px;
        }
      }
    }
  }
}
// 常见申报项
.decl-options {
  // width: 100%;
  width: 1040px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  // padding: 0 10%;
  box-sizing: border-box;
  padding-bottom: 50px;
  .options-h1 {
    padding: 30px 0;
    color: #000;
  }
  .options-items {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .item {
      width: 32%;
      position: relative;
      border-radius: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-bottom: 13px;
      .item-text-h4 {
        transform: skewX(-30deg);
        background: #ffffff;
        width: 70%;
        margin-top: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        h4 {
          transform: skewX(30deg);
          font-size: 15px;
        }
      }
      .item-text-h4-three {
        height: 66px;
      }
      .item-content {
        margin-top: 20px;
        .content-text {
          font-size: 11px;
          margin-left: 15px;
          margin-right: 15px;
          .text-h4 {
            margin-bottom: 10px;
          }
          .text-line {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .line-num {
              // width: 25px;
              flex: 1;
              p {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ffffff;
                font-size: 13px;
                font-weight: 700;
              }
            }
            .line-title {
              flex: 2;
              p {
                height: 22px;
                border-radius: 11px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ffffff;
                font-size: 12px;
                font-weight: 700;
              }
            }
            .line-msg {
              flex: 4;
              p {
                height: 22px;
                padding-left: 10px;
                display: flex;
                align-items: center;
                justify-items: flex-end;
                color: #ffffff;
                line-height: 12px;
              }
            }
          }
          .apply {
            margin-bottom: 10px;
          }
        }
        .content-text > p {
          line-height: 20px;
          color: #ffffff;
          margin-bottom: 10px;
        }
      }
    }
    .item1 {
      background: rgb(93, 124, 238);
    }
    .item2 {
      background: rgb(68, 206, 164);
    }
    .item3 {
      background: rgb(240, 173, 72);
    }
    .h4-blue {
      color: rgb(93, 124, 238);
    }
    .h4-green {
      color: rgb(68, 206, 164);
    }
    .h4-yellow {
      color: rgb(240, 173, 72);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/declaration/declaration.vue